import React, { useState, useEffect } from "react";
import '../../index.css';

const initialFees = [
  { id: 1, interval: "Monthly", viewBy: "Automatic", feeFor: "School" },
  { id: 2, interval: "Yearly", viewBy: "Automatic", feeFor: "Admission" },
  { id: 3, interval: "Monthly", viewBy: "Automatic", feeFor: "Transport" },
  { id: 4, interval: "Monthly", viewBy: "Automatic", feeFor: "Hostel" },
];

export default function FeeSetup() {

  const STORAGE_KEY = "fees";
  const [feeList, setFeeList] = useState([]);
  const [selectedFee, setSelectedFee] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    interval: "",
    viewBy: "Automatic",
    feeFor: ""
  });

  // 🔍 FILTER (now using feeFor)
  const filteredFees = feeList.filter((f) =>
    f.feeFor.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ADD
  const openAddModal = () => {
    setIsEdit(false);
    setFormData({
      id: "",
      interval: "",
      viewBy: "Automatic",
      feeFor: ""
    });
    setShowModal(true);
  };

  // EDIT
  const openEditModal = () => {
    if (!selectedFee) return alert("Select a Fee first");
    setIsEdit(true);
    setFormData(selectedFee);
    setShowModal(true);
  };

  // DELETE
  const handleDelete = () => {
    if (!selectedFee) return alert("Select a Fee first");

    const updated = feeList.filter(f => f.id !== selectedFee.id);

    setFeeList(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    window.dispatchEvent(new Event("storage"));

    setSelectedFee(null);
  };

  // SAVE
  const handleSave = () => {
    if (!formData.interval || !formData.feeFor) {
      return alert("All fields required");
    }

    let updatedList = [];

    if (isEdit) {
      updatedList = feeList.map(f =>
        f.id === formData.id ? formData : f
      );
    } else {
      updatedList = [
        { ...formData, id: Date.now() },
        ...feeList
      ];
    }

    setFeeList(updatedList);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedList));
    window.dispatchEvent(new Event("storage"));

    setShowModal(false);
    setSelectedFee(null);
  };

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

    if (saved.length === 0) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(initialFees));
      setFeeList(initialFees);
    } else {
      setFeeList(saved);
    }
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      setFeeList(saved);
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  return (
    <>
      <style>{`
        .page { background:#f5f7fb; padding:20px; }
        .card { background:#fff; padding:15px; border-radius:8px; }

        .header { display:flex; justify-content:space-between; margin-bottom:10px; }

        .controls { display:flex; gap:10px; margin-bottom:10px; flex-wrap:wrap; }

        .search-box {
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        .btn { padding:7px 12px; border:none; border-radius:4px; cursor:pointer; }
        .btn-dark { background:#2c3e50; color:white; }
        .btn-blue { background:#3498db; color:white; }
        .btn-red { background:#e74c3c; color:white; }

        table { width:100%; border-collapse:collapse; }
        th, td { padding:10px; border-bottom:1px solid #eee; }

        tr:hover { background:#f4f6f9; cursor:pointer; }
        .active-row { background:#eef3ff; }

        input[type="checkbox"] { cursor:pointer; }

        .modal {
          position:fixed;
          top:0;
          left:0;
          width:100%;
          height:100%;
          background:rgba(0,0,0,0.5);
          display:flex;
          justify-content:center;
          align-items:center;
        }

        .modal-content {
          background:white;
          padding:20px;
          border-radius:8px;
          width:350px;
        }

        .modal-content select {
          width:100%;
          margin-bottom:10px;
          padding:8px;
        }
      `}</style>

      <div className="page">
        <div className="card">

          {/* HEADER */}
          <div className="header">
            <h3>Fee Setup</h3>
            <div>{feeList.length} Records</div>
          </div>

          {/* CONTROLS */}
          <div className="controls">

            <input
              className="search-box"
              placeholder="Search Fee For"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <button className="btn btn-dark" onClick={openAddModal}>
              + Add Fee
            </button>

            <button className="btn btn-blue" onClick={openEditModal}>
              Update
            </button>

            <button className="btn btn-red" onClick={handleDelete}>
              Delete
            </button>
          </div>

          {/* TABLE */}
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Fee For</th>
                <th>Collection Interval</th>
                <th>View By</th>
              </tr>
            </thead>

            <tbody>
              {filteredFees.map((f) => (
                <tr
                  key={f.id}
                  className={selectedFee?.id === f.id ? "active-row" : ""}
                  onClick={() =>
                    setSelectedFee(selectedFee?.id === f.id ? null : f)
                  }
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedFee?.id === f.id}
                      onChange={() =>
                        setSelectedFee(selectedFee?.id === f.id ? null : f)
                      }
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>

                  <td>{f.feeFor}</td>
                  <td>{f.interval}</td>
                  <td>{f.viewBy}</td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>

        {/* MODAL */}
        {showModal && (
          <div className="modal">
            <div className="modal-content">

              <h3>{isEdit ? "Update Fee" : "Add Fee"}</h3>

              {/* Fee For Dropdown */}
              <select
                value={formData.feeFor}
                onChange={(e) =>
                  setFormData({ ...formData, feeFor: e.target.value })
                }
              >
                <option value="">Select Fee For</option>
                <option value="Transport">Transport</option>
                <option value="Admission">Admission</option>
                <option value="Hostel">Hostel</option>
                <option value="Book">Book</option>
                <option value="Dress">Dress</option>
                <option value="Other">Other</option>
              </select>

              {/* Interval */}
              <select
                value={formData.interval}
                onChange={(e) =>
                  setFormData({ ...formData, interval: e.target.value })
                }
              >
                <option value="">Select Interval</option>
                <option value="Monthly">Monthly</option>
                <option value="Quarterly">Quarterly</option>
                <option value="Yearly">Yearly</option>
                <option value="OneTime">One Time</option>
              </select>

              {/* View By */}
              <select
                value={formData.viewBy}
                onChange={(e) =>
                  setFormData({ ...formData, viewBy: e.target.value })
                }
              >
                <option value="Automatic">Automatic</option>
                <option value="Manual">Manual</option>
              </select>

              <div style={{ display: "flex", gap: "10px" }}>
                <button className="btn btn-blue" onClick={handleSave}>
                  Save
                </button>

                <button
                  className="btn btn-red"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
              </div>

            </div>
          </div>
        )}

      </div>
    </>
  );
}